export default __webpack_public_path__ + "static/achieve-uk-web-a97da4c5bcd4b2556ff645c7db4143be.webp";